import Component from '@cell/cell-core/component/component';
import './collection-main.scss';

class CollectionMain extends Component {
  constructor() {
    super();

    this.templates = [];

    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.on('c-filters.submit', this.update);
    this.on('c-filter.remove-filter', this.update);
    this.on('filter-value.add', this.update);
    this.on('filter-value.remove', this.update);
    this.on('filter-mobile.remove', this.update);
    this.on('c-filters.remove-active-value', this.update);
    this.on('c-filters.remove-all-filters', this.update);
    this.on('filters-mobile.remove-all-filters', this.update);
  }

  async update({ data }) {
    const { url } = data;

    if (!url) {
      throw new Error("Can't update collection-main. Missing URL.");
    }

    this.setLoading();

    const template = await this.fetchTemplate(url);

    this.updateURL(url);
    this.rerender(template);
  }

  async fetchTemplate(url) {
    // Check if the template with the provided url has already been fetched.

    const existingTemplate = this.templates.find((template) => template.url === url);

    if (existingTemplate) {
      return existingTemplate.template;
    }

    const res = await fetch(url);

    const resText = await res.text();
    const template = new DOMParser().parseFromString(resText, 'text/html');

    this.templates.push({
      url,
      template,
    });

    return template;
  }

  rerender(template) {
    this.rerenderFilters(template);
    this.rerenderProductList(template);
  }

  rerenderFilters(template) {
    const componentsToRerender = [
      'dropdown-trigger',
      'filter-value',
      '.Filters__ActiveTags',
      '.Filter__Actions',
      '.FilterMobile__Label',
      '.FilterMobile__Actions',
      '.FiltersMobile__OpenTrigger',
    ];

    componentsToRerender.forEach((component) => {
      const componentInstances = this.querySelectorAll(component);
      const templateComponentInstances = template.querySelectorAll(component);

      componentInstances.forEach((componentInstance, index) => {
        componentInstance.outerHTML = templateComponentInstances[index].outerHTML;
      });
    });
  }

  rerenderProductList(template) {
    const componentsToRerender = [
      '.ProductList',
      "[data-experiment='new-collection-page-layout'][data-variant] .ProductListWrapper",
      '.ProductListWrapper--NoSubCollections',
    ];

    componentsToRerender.forEach((component) => {
      const oldElement = this.querySelector(component);
      const newElement = template.querySelector(component);

      if (oldElement && newElement) {
        this.querySelector(component).outerHTML = template.querySelector(component).outerHTML;
      }
    });
  }

  updateURL(url) {
    window.history.replaceState({}, '', url);
  }

  setLoading() {
    const filterValueElements = this.querySelectorAll('filter-value');

    filterValueElements.forEach((element) => {
      element.setLoading();
    });
  }
}

customElements.define('collection-main', CollectionMain);
